"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findIndex = exports.conservatively = exports.setKey = exports.structEq = void 0;
const equals_1 = require("./equals");
var equals_2 = require("./equals");
Object.defineProperty(exports, "structEq", { enumerable: true, get: function () { return equals_2.equals; } });
function setKey(k, v, o) {
    if (k in o && equals_1.equals(v, o[k])) {
        return o;
    }
    else {
        // this is the fastest way to do it, see
        // https://jsperf.com/focal-setkey-for-loop-vs-object-assign
        const r = {};
        for (const p in o)
            r[p] = o[p];
        r[k] = v;
        return r;
    }
}
exports.setKey = setKey;
/**
 * 'Conserve' a value's identity if its structure doesn't change.
 */
function conserve(x, y) {
    return equals_1.equals(x, y) ? y : x;
}
/**
 * Make a fold function's behaviour conservative in its input value's
 * identity.
 */
function conservatively(fn) {
    return (y, c0) => conserve(fn(y, c0), c0);
}
exports.conservatively = conservatively;
function findIndex(xs, p) {
    for (let i = 0; i < xs.length; i++) {
        if (p(xs[i]))
            return i;
    }
    return -1;
}
exports.findIndex = findIndex;
